import { createCdnThumbnailUrl } from "../config/cdn";

/** Board mapped to the shape the smart-quote page's vanilla choose() expects. */
export interface MappedBoard {
    id_board: string;
    name: string;
    thickness: number | null;
    thumb: string;
    sheet_price: number | null; // gross Ft/tábla
    m2_price: number | null;    // gross Ft/m²
    calc_method: string | null;
    /** grain-directional decor: parts can't be rotated freely by the optimizer */
    oriented: boolean;
    compatible_edges: string[];
}

/** Reuse the configurator's own board endpoint (gross prices computed server-side). */
export async function loadBoards(shopId: number): Promise<MappedBoard[]> {
    const url = "/index.php?fc=module&module=ubercabinet&controller=db&table=uc_boards&id_shop=" + encodeURIComponent(String(shopId));
    let rows: any[] = [];
    try {
        const data = await (await fetch(url)).json();
        rows = Array.isArray(data) ? data : [];
    } catch (e) {
        rows = [];
    }
    return rows.map((r) => ({
        id_board: String(r.ID),
        name: (Array.isArray(r.OverrideNames) && r.OverrideNames[0]) ? String(r.OverrideNames[0]) : String(r.Name ?? ""),
        thickness: r.SheetThickness ?? null,
        thumb: createCdnThumbnailUrl(r.ProductImage),
        sheet_price: r.GrossSheetPrice ?? null,
        m2_price: r.GrossUnitPrice ?? null,
        calc_method: r.CalcMethod ?? null,
        oriented: r.Oriented == 1,
        compatible_edges: Array.isArray(r.CompatibleEdgings) ? r.CompatibleEdgings.map(String) : [],
    }));
}
